<template>
  <div class="page">
    <div id="pdfContent1" class="pdf-box">
      <div>
        <div class="con-box">
          <MainTitle title="体能发育对比" tag="综合能力状态分布" />
          <div class="clearfix mt30">
            <BasePanel
              v-if="frirstChartData.title"
              padding="20px"
              :style="{width: dataLength > 3 ? '100%' : ''}"
              class="chart-item"
              :title="frirstChartData.title"
              title-color="#fff"
              head-bg="#FF7146"
              head-border-color="#FF7146"
            >
              <BarDashedLine
                :data-list="frirstChartData.details"
                :color-list="colorList"
              />
            </BasePanel>
            <BasePanel
              v-for="(item, index) in barDataArray"
              :key="index"
              :style="{width: dataLength > 3 ? '100%' : ''}"
              :title="item.title"
              padding="20px"
              class="chart-item"
            >
              <BarDashedLine
                :data-list="item.details"
                :color-list="colorList"
              />
            </BasePanel>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  groupCompareSynthEZDistributeScoreType,
  getClassList
} from '@/api/teachingProtection/assessment'
import BasePanel from './BasePanel.vue'
import BarDashedLine from '../../_components/charts/BarDashedLine.vue'
import MainTitle from './MainTitle.vue'

export default {
  components: {
    BasePanel,
    BarDashedLine,
    MainTitle
  },
  props: {
    data: {},
    searchParams: {}
  },
  data() {
    return {
      frirstChartData: {},
      barDataArray: [],
      colorList: ['#F87A52', '#FFA100', '#6DD400', '#3A91FF', '#A35DFF'],
      classroomName: '',
      sexName: '',
      ageName: '',
      dataLength: 0
    }
  },
  created() {
    if (!this.searchParams) return
    let params = this.searchParams
    const classroomNames = []
    const sexNames = []
    const ageNames = []
    getClassList({
      periodType: params.periodType,
      year: params.year,
      semesterType: params.semesterType
    }).then((res) => {
      res.data.array.map((v) => {
        v.classrooms.map((q) => {
          if (params.classroomIds.indexOf(q.id) !== -1) {
            classroomNames.push(q.name)
          }
        })
      })
      this.classroomName = classroomNames.join('、')
    })
    this.$enums.gender.map((v) => {
      if (params.sexes.indexOf(v.code) !== -1) {
        sexNames.push(v.description)
      }
    })
    this.sexName = sexNames.join('、')
    groupCompareSynthEZDistributeScoreType(params).then((res) => {
      this.dataLength = res.data.synthEZDistributeScoreType.details.length
      this.frirstChartData = res.data.synthEZDistributeScoreType
      this.barDataArray = res.data.barChart || []
    })
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.pdf-box {
  width: 1200px;
  background: #ffffff;
  // transform: scale(0.9);
  // transform-origin: 0 0 0;
  .con-box {
    padding: 30px;
  }
}
.search-term {
  min-width: 100px;
}
.search-con {
  background: #f0f4f7;
  border-radius: 2px;
  padding: 5px 10px;
  max-width: 600px;
  margin-left: 20px;
  line-height: 20px;
}
.type-box {
  font-size: 12px;
  .name {
    font-weight: 500;
    font-size: 22px;
    color: #333333;
    line-height: 30px;
    text-align: left;
    font-style: normal;
  }
  .val {
    color: #ff6c14;
  }
}
.chart-item {
  float: left;
  width: 360px;
  height: 330px;
  margin-right: 20px;
  margin-bottom: 20px;
}
.tips {
  height: 51px;
  line-height: 51px;
  margin-right: 20px;

  .item {
    float: left;
    margin-right: 20px;
    position: relative;
    padding-left: 20px;
    i {
      position: absolute;
      content: "";
      left: 0px;
      top: 17px;
      height: 15px;
      width: 15px;
    }
  }
}
</style>
